// Syntax highlighting for the editor: Prism, loaded the first time a file is opened (it isn't
// needed anywhere else on the site).
let loading = null;

const loadPrism = () => {
  if (!loading) {
    loading = import("prismjs").then(async ({ default: Prism }) => {
      await import("prismjs/components/prism-jsx");
      await import("prismjs/components/prism-json");
      await import("prismjs/components/prism-markdown");
      return Prism;
    });
  }
  return loading;
};

const LANGUAGES = { js: "jsx", jsx: "jsx", css: "css", json: "json", md: "markdown", html: "markup", svg: "markup" };

// Past this, a file shows as plain text, as highlighting it would hold the page up.
const MAX_HIGHLIGHT = 200 * 1024;

// The file's text as highlighted HTML (Prism escapes it), or null to show it plain.
export const highlight = async (text, name) => {
  const language = LANGUAGES[name.split(".").pop().toLowerCase()];
  if (!language || text.length > MAX_HIGHLIGHT) return null;
  const Prism = await loadPrism();
  return Prism.highlight(text, Prism.languages[language], language);
};
